import { configService, UtilitiesFunctions } from '@/helpers';
import { Suggestion } from '@/interfaces/suggestion';
import i18n from "../../plugins/i18n";
import { VueRouter } from 'vue-router/types/router';

let abortCtrl: AbortController;

type SuggestionType = 'experience' | 'region' | 'winery' | 'experience-search' | 'region-search' | 'winery-search' | 'wineregion' | 'city' | 'product';

export interface SuggestionItem {
  title?: string;
  count?: number;
  type: SuggestionType;
  subtitle?: string;
  key: string;
  data: any;
}

export function fetchSuggestions(input: string): Promise<SuggestionItem[]> {
  if (!input) return Promise.reject(null);
  if (abortCtrl) {
    abortCtrl.abort()
  }
  abortCtrl = new AbortController();
  return fetch(`${configService.search}/?q=${input}`, { signal: abortCtrl.signal })
    .then(r => r.json())
    .then((suggestion: Suggestion) => {
      const items: any = [];

      /* push regions */
      items.push(...suggestion.regions.matches.map(match => ({
        title: match.name,
        type: 'region',
        avatar: null,
        subtitle: i18n.t('suggestions.regionSuggestionTypeLabel'),
        count: i18n.tc('suggestions.experienceCount', match.experience_count, { count: match.experience_count }),
        key: `${match.name}-region`,
        data: match.id
      })))

      /* push wine regions */
      items.push(...suggestion.wine_regions.matches.map(match => ({
        title: match.name,
        type: 'wineregion',
        avatar: null,
        subtitle: i18n.t('suggestions.wineRegionSuggestionTypeLabel'),
        count: i18n.tc('suggestions.experienceCount', match.experience_count, { count: match.experience_count }),
        key: `${match.name}-wineregion`,
        data: match.id
      })))

      /* push products */
      items.push(...suggestion.products.matches.map(match => ({
        title: match.name,
        type: 'product',
        subtitle: i18n.t('suggestions.productSuggestionTypeLabel'),
        count: i18n.tc('suggestions.experienceCount', match.experience_count, { count: match.experience_count }),
        key: `${match.name}-product`,
        data: match.id,
        avatar: match.avatar_image
      })))


      /* push city regions */
      items.push(...suggestion.cities.matches.map(match => ({
        title: match.city,
        type: 'city',
        avatar: null,
        subtitle: i18n.t('suggestions.citySuggestionTypeLabel'),
        count: i18n.tc('suggestions.experienceCount', match.experience_count, { count: match.experience_count }),
        key: `${match.city}-city`,
        data: match.city
      })))

      /* push wineries */
      /* TODO: needs textual cantine search
       if (suggestion.companies.total > 0) {
       items.push({
       title: input,
       count: i18n.tc('suggestions.wineryCount', suggestion.companies.total, { count: suggestion.companies.total }),
       type: 'winery-search',
       subtitle: i18n.t('suggestions.searchWineriesLabel'),
       key: `${input}-winery-search`,
       })
       }
       */
      items.push(...suggestion.companies.matches.map(match => ({
        title: match.name,
        count: i18n.tc('suggestions.experienceCount', match.experience_count, { count: match.experience_count }),
        type: 'winery',
        avatar: match.avatar_image,
        subtitle: i18n.t('suggestions.winerySuggestionTypeLabel'),
        key: `${match.name}-winery`,
        data: match.id
      })))

      /* push experiences */
      if (suggestion.experiences.total > 3) {
        items.push({
          title: input,
          count: i18n.tc('suggestions.experienceCount', suggestion.experiences.total, { count: suggestion.experiences.total }),
          type: 'experience-search',
          subtitle: i18n.t('suggestions.searchExperiencesLabel'),
          key: `${input}-experience-search`
        })
      }
      items.push(...suggestion.experiences.matches.map(match => ({
        title: match.title_translations['it'],
        count: null,
        type: 'experience',
        avatar: match.avatar_image,
        subtitle: i18n.t('suggestions.experienceSuggestionTypeLabel'),
        key: `${match.title_translations['it']}-experience`,
        data: match.id
      })))

      return items;
    })
}

export function acceptSuggestion(router: VueRouter, item: SuggestionItem) {
  let id, base, rdata;
  switch (item.type) {
    case 'experience':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('experience');
      rdata = router.resolve({
        path: `${base}/${id}`
      })
      window.open(rdata.href, '_blank');
      break;
    case 'winery':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('cellar');
      rdata = router.resolve({
        path: `${base}/${id}`
      })
      window.open(rdata.href, '_blank');
      break;
    case 'region':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('experiences');
      rdata = router.resolve({
        path: `${base}`,
        query: {
          region: id
        }
      })
      window.open(rdata.href, '_self');
      break;
    case 'wineregion':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('experiences');
      rdata = router.resolve({
        path: `${base}`,
        query: {
          wineregion: id
        }
      })
      window.open(rdata.href, '_self');
      break;
    case 'city':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('experiences');
      rdata = router.resolve({
        path: `${base}`,
        query: {
          city: id
        }
      })
      window.open(rdata.href, '_self');
      break;
    case 'product':
      id = item.data;
      base = UtilitiesFunctions.handleRoute('experiences');
      rdata = router.resolve({
        path: `${base}`,
        query: {
          product: id
        }
      })
      window.open(rdata.href, '_self');
      break;
    case 'experience-search':
      const term = item.title;
      base = UtilitiesFunctions.handleRoute('experiences');
      rdata = router.resolve({
        path: `${base}`,
        query: {
          term
        }
      })
      window.open(rdata.href, '_self');
      break;
  }
}
